import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-background-50">
                日本女优大全
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最全面的日本演艺女优参考资源，收录数千位女优的详细资料与最新动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">首页</Link>
              <Link to="/category/drama-actress" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">影视剧女优</Link>
              <Link to="/category/new-generation" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">新生代女优</Link>
              <Link to="/category/popular-ranking" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">人气排行榜</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于本站
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">关于我们</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">使用条款</a>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">免责声明</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-300">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                <span>contact@ribennvyou.com</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span>日本东京都</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 日本女优大全 RibenNvyou.com - 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 transition-colors cursor-pointer" aria-label="Twitter">
              <i className="ri-twitter-x-line text-sm text-foreground-300"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 transition-colors cursor-pointer" aria-label="Instagram">
              <i className="ri-instagram-line text-sm text-foreground-300"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 hover:bg-foreground-700/50 transition-colors cursor-pointer" aria-label="LINE">
              <i className="ri-line-line text-sm text-foreground-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}